/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedResponse } from '../../models/paginated-response';

export interface ProductsControllerFindAll$Params {
  page?: number;
  limit?: number;
  search?: string;
  categoryId?: string;
  isActive?: boolean;
  sortBy?: 'name' | 'priceCents' | 'sortOrder' | 'createdAt';
  sortOrder?: 'ASC' | 'DESC';
}

export function productsControllerFindAll(http: HttpClient, rootUrl: string, params?: ProductsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, productsControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('categoryId', params.categoryId, {});
    rb.query('isActive', params.isActive, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

productsControllerFindAll.PATH = '/products';
